function camelCaseToDashCase(camelCase: string) {
  return camelCase.replace(/[A-Z]/g, _ => '-' + _.toLowerCase());
}

export { camelCaseToDashCase };
